<template>  
  <div class="footer" :class="{'footer--fixed' : isSplash}">
    <a class="footer-logo-link" target="_blank">
      <img src="../assets/logo_new.png" alt="Refinitiv Labs" v-if="!isSplash"/>
      <!-- <img src="https://s3-eu-west-1.amazonaws.com/auth-lib/assets/refinitiv_labs_logo_cropped.svg" alt="Refinitiv Labs" v-if="isSplash"/> -->
    </a>
    <nav class="footer-nav">
      <!-- <a target="_blank" href="https://www.refinitiv.com/en/policies/privacy-statement#cookies"> -->
      <a href="https://www.refinitiv.com/en/policies/privacy-statement#cookies" target="_blank" rel="noopener">
        Cookies<span class="visible-not-mobile"> Policy</span>
      </a>
      <!-- <a target="_blank" href="https://www.refinitiv.com/en/policies/privacy-statement"> -->
      <a href="https://www.refinitiv.com/en/policies/privacy-statement" target="_blank" rel="noopener">
        Privacy<span class="visible-not-mobile"> Statement</span>
      </a>
      <!-- <a target="_blank" href="https://www.refinitiv.com/en/policies/terms-of-use"> -->
      <a href="https://www.refinitiv.com/en/policies/terms-of-use" target="_blank" rel="noopener">
        Terms<span class="visible-not-mobile"> of Use</span>
      </a>
    </nav>
  </div>
</template>


<script lang="ts">

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class Footer extends Vue {
  get isSplash() {
    return this.$route.name === 'login';

  }
}

</script>

<style scoped lang="scss">
  .footer {
    width: 100%;
    border-top: 1px solid #dcdcdc;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 22px;
    background-color: transparent;

    &--fixed {
      position: fixed;
      bottom: 0;
      border-color: rgba(255, 255, 255, .3);

      .footer-nav {
        a {
          color: #fff;

          &:hover {
            opacity: .6;
          }
        }
      }
    }

    .footer-logo-link {
      display: flex;
      align-items: center;
      height: 100%;

      img {
        height: 16px;
        @media only screen and (min-width: 992px) {
          height : 22px;
        }
      }

      &:hover {
        opacity: .8;
      }
    }

    .footer-nav {
      a {
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
</style>